import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

// for local environment don't turn on Sentry for any logging nor tracing
if (environment.name !== 'default' && environment.name !== 'dev' && environment.name !== 'local') {
  Sentry.init({
    dsn: 'https://75794090e88b4d31ad570505ee976abd@o4512283807580160.ingest.sentry.io/4505125554225152',
    environment: environment.name,
    release: environment.version,
    integrations: [Sentry.browserTracingIntegration()],
    initialScope: {
      tags: {
        product: 'Dashboard',
      },
    },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.7,
    enabled: true,

    // ignore errors
    ignoreErrors: [],
    denyUrls: [
      // unreliable service
      /api\.weather\.gov/i,
    ],
  });
}

bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch(err =>
  console.error(err)
);
